import React, { useState } from "react";
import PropTypes from "prop-types";
import { ConfirmModal } from "../../../../boxes/ConfirmModal/ConfirmModal";
import { uiNotification } from "../../../../services/UINotificationService";

/*
 * Shown after a text2pay booking. The slot is held but the appointment is not
 * confirmed until the link is paid, so this states what happens next and always
 * offers the link — the text can fail while the booking itself succeeds.
 */
const AppointmentPendingPaymentModal = ({
  isOpen,
  onClose,
  paymentLink,
  isLinkSent,
  expiresInMinutes,
}) => {
  const [isCopied, setIsCopied] = useState(false);

  const onCopy = async () => {
    try {
      await navigator.clipboard.writeText(paymentLink);
      setIsCopied(true);
    } catch (e) {
      uiNotification.error("Could not copy the payment link");
    }
  };

  return (
    <ConfirmModal
      isOpen={isOpen}
      onClose={onClose}
      onConfirm={paymentLink ? onCopy : undefined}
      onCancel={onClose}
      confirmTitle={isCopied ? "Copied" : "Copy payment link"}
      cancelTitle="Done"
      title="Appointment reserved"
    >
      <div>
        {isLinkSent
          ? "We texted the patient a payment link. The appointment is confirmed once they pay it."
          : "The appointment is reserved, but we could not text the payment link. Share it with the patient to confirm the booking."}
      </div>
      {expiresInMinutes && (
        <div className="m-t-10">
          {`The slot is held for ${expiresInMinutes} minutes. If the link is not paid by then, the slot is released.`}
        </div>
      )}
      {!paymentLink && (
        <div className="m-t-10">
          No payment link could be generated. Please rebook the appointment.
        </div>
      )}
    </ConfirmModal>
  );
};

AppointmentPendingPaymentModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  paymentLink: PropTypes.string,
  isLinkSent: PropTypes.bool,
  expiresInMinutes: PropTypes.number,
};

AppointmentPendingPaymentModal.defaultProps = {
  paymentLink: "",
  isLinkSent: false,
  expiresInMinutes: null,
};

export default AppointmentPendingPaymentModal;
